// React
import React from "react";
// React
// CSS
import styles from "./Footer.module.css";
// CSS
// Icons
import {
  AiFillHome,
  AiOutlineQuestionCircle,
  AiOutlineShoppingCart,
  AiFillYoutube,
  AiFillMail,
} from "react-icons/ai";
import { FaUser } from "react-icons/fa";
// Icons
// Components
import { NavLink } from "react-router-dom";
// Components

const Footer = () => {
  return (
    <div
      className={`${styles.footer} flex flex-row-reverse items-center fixed bottom-0`}
      id="footer"
    >
      <NavLink
        style={({ isActive }) => ({
          background: isActive ? "rgb(126 , 58 , 209)" : "transparent",
          color: !isActive ? "#858585" : "#fff",
        })}
        to={"/"}
      >
        <AiFillHome
          style={{
            fontSize: "2.5vh",
          }}
        />
        <span
          style={{
            fontSize: "1.8vh",
          }}
        >
          فیلم‌ها
        </span>
      </NavLink>
      {/* <NavLink
        style={({ isActive }) => ({
          background: isActive ? "rgb(126 , 58 , 209)" : "transparent",
          color: !isActive ? "#858585" : "#fff",
        })}
        to={"/quiz-maker"}
      >
        <AiOutlineQuestionCircle
          style={{
            fontSize: "1.8vh",
          }}
        />
        <span
          style={{
            fontSize: "1.8vh",
          }}
        >
          آزمون ساز
        </span>
      </NavLink> */}
      <NavLink
        style={({ isActive }) => ({
          background: isActive ? "rgb(126 , 58 , 209)" : "transparent",
          color: !isActive ? "#858585" : "#fff",
        })}
        to={"/shop"}
      >
        <AiOutlineShoppingCart
          style={{
            fontSize: "1.8vh",
          }}
        />
        <span
          style={{
            fontSize: "1.8vh",
          }}
        >
          جزوات
        </span>
      </NavLink>
      <NavLink
        style={({ isActive }) => ({
          background: isActive ? "rgb(126 , 58 , 209)" : "transparent",
          color: !isActive ? "#858585" : "#fff",
        })}
        to={"/profile"}
      >
        <FaUser
          style={{
            fontSize: "1.8vh",
          }}
        />
        <span
          style={{
            fontSize: "1.8vh",
          }}
        >
          پروفایل
        </span>
      </NavLink>
      <NavLink
        style={({ isActive }) => ({
          background: isActive ? "rgb(126 , 58 , 209)" : "transparent",
          color: !isActive ? "#858585" : "#fff",
        })}
        to={"/question-bank"}
      >
        <AiOutlineQuestionCircle
          style={{
            fontSize: "1.8vh",
          }}
        />
        <span
          style={{
            fontSize: "1.8vh",
          }}
        >
          بانک سوال
        </span>
      </NavLink>
      <NavLink
        style={({ isActive }) => ({
          background: isActive ? "rgb(126 , 58 , 209)" : "transparent",
          color: !isActive ? "#858585" : "#fff",
        })}
        to={"/ticketing"}
      >
        <AiFillMail
          style={{
            fontSize: "1.8vh",
          }}
        />
        <span
          style={{
            fontSize: "1.3vh",
          }}
        >
          تیکت‌و پشتیبانی
        </span>
      </NavLink>
      {/* <NavLink
        style={({ isActive }) => ({
          background: isActive ? "rgb(126 , 58 , 209)" : "transparent",
          color: !isActive ? "#858585" : "#fff",
        })}
        to={"/ads"}
      >
        <AiFillYoutube
          style={{
            fontSize: "1.8vh",
          }}
        />
        <span
          style={{
            fontSize: "1.8vh",
          }}
        >
          تبلیغات
        </span>
      </NavLink> */}
    </div>
  );
};

export default Footer;
